import React, { useState } from 'react';
import StatusBar from '../components/common/StatusBar';
import VirtualKeypad from '../components/common/VirtualKeypad';

// Composants spécifiques workshop (à créer plus tard)
const EditableLineTable = () => {
  const [lines, setLines] = useState([
    { id: 1, description: 'Réparation moteur', quantity: 1, unitPrice: 150.00, total: 150.00 },
    { id: 2, description: 'Pièces détachées', quantity: 2, unitPrice: 45.50, total: 91.00 },
    { id: 3, description: 'Main d\'œuvre', quantity: 3, unitPrice: 35.00, total: 105.00 },
  ]);

  const addLine = () => {
    const newLine = {
      id: Date.now(),
      description: '',
      quantity: 1,
      unitPrice: 0,
      total: 0
    };
    setLines([...lines, newLine]);
  };

  const updateLine = (id, field, value) => {
    setLines(lines.map(line => {
      if (line.id === id) {
        const updatedLine = { ...line, [field]: value };
        if (field === 'quantity' || field === 'unitPrice') {
          updatedLine.total = updatedLine.quantity * updatedLine.unitPrice;
        }
        return updatedLine;
      }
      return line;
    }));
  };

  const removeLine = (id) => {
    setLines(lines.filter(line => line.id !== id));
  };

  const subtotal = lines.reduce((sum, line) => sum + line.total, 0);
  const tax = subtotal * 0.20;
  const total = subtotal + tax;

  return (
    <div className="bg-white rounded-lg shadow-sm border h-full flex flex-col">
      <div className="p-4 border-b bg-gray-50">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-800">Lignes de devis</h3>
          <button
            onClick={addLine}
            className="px-3 py-1 bg-blue-500 text-white rounded-lg text-sm hover:bg-blue-600"
          >
            + Ajouter ligne
          </button>
        </div>
      </div>
      
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="space-y-3">
          {lines.map((line) => (
            <div key={line.id} className="bg-gray-50 rounded-lg p-3 border">
              <div className="grid grid-cols-12 gap-2 items-center">
                <div className="col-span-5">
                  <input
                    type="text"
                    value={line.description}
                    onChange={(e) => updateLine(line.id, 'description', e.target.value)}
                    placeholder="Description"
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div className="col-span-2">
                  <input
                    type="number"
                    value={line.quantity}
                    onChange={(e) => updateLine(line.id, 'quantity', parseFloat(e.target.value) || 0)}
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div className="col-span-2">
                  <input
                    type="number"
                    step="0.01"
                    value={line.unitPrice}
                    onChange={(e) => updateLine(line.id, 'unitPrice', parseFloat(e.target.value) || 0)}
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div className="col-span-2 text-right font-medium">
                  {line.total.toFixed(2)} €
                </div>
                <div className="col-span-1">
                  <button
                    onClick={() => removeLine(line.id)}
                    className="text-red-500 hover:text-red-700 text-sm"
                  >
                    ✕
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Résumé */}
        <div className="mt-4 p-3 bg-gray-100 rounded-lg">
          <div className="space-y-1 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Sous-total:</span>
              <span className="font-medium">{subtotal.toFixed(2)} €</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">TVA (20%):</span>
              <span className="font-medium">{tax.toFixed(2)} €</span>
            </div>
            <div className="flex justify-between text-lg font-bold border-t pt-1">
              <span>Total:</span>
              <span className="text-green-600">{total.toFixed(2)} €</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ClientSelector = () => {
  const clients = [
    { id: 1, name: 'Garage Martin', phone: '01 23 45 67 89', address: '123 Rue de la Paix' },
    { id: 2, name: 'Auto Service Plus', phone: '01 98 76 54 32', address: '456 Avenue des Champs' },
    { id: 3, name: 'Mécanique Express', phone: '01 11 22 33 44', address: '789 Boulevard Central' },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border h-full flex flex-col">
      <div className="p-4 border-b bg-gray-50">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold text-gray-800">Client</h3>
          <button className="px-3 py-1 bg-green-500 text-white rounded-lg text-sm hover:bg-green-600">
            + Nouveau
          </button>
        </div>
        <input
          type="text"
          placeholder="Rechercher un client..."
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="space-y-2">
          {clients.map((client) => (
            <div
              key={client.id}
              className="p-3 bg-gray-50 rounded-lg cursor-pointer hover:bg-blue-50 transition-colors border"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center text-orange-600 font-semibold">
                  {client.name.charAt(0)}
                </div>
                <div className="flex-1">
                  <div className="font-medium text-sm text-gray-800">{client.name}</div>
                  <div className="text-xs text-gray-500">{client.phone}</div>
                  <div className="text-xs text-gray-400">{client.address}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const DevisPreview = () => {
  const devisData = {
    number: 'DEV-2024-001',
    date: new Date().toLocaleDateString('fr-FR'),
    client: 'Garage Martin',
    lines: [
      { description: 'Réparation moteur', quantity: 1, unitPrice: 150.00, total: 150.00 },
      { description: 'Pièces détachées', quantity: 2, unitPrice: 45.50, total: 91.00 },
      { description: 'Main d\'œuvre', quantity: 3, unitPrice: 35.00, total: 105.00 },
    ],
    subtotal: 346.00,
    tax: 69.20,
    total: 415.20
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border h-full flex flex-col">
      <div className="p-4 border-b bg-gray-50">
        <h3 className="text-lg font-semibold text-gray-800">Aperçu devis</h3>
      </div>
      
      <div className="flex-1 p-4 overflow-y-auto">
        <div className="space-y-4">
          {/* En-tête */}
          <div className="text-center border-b pb-3">
            <h4 className="text-lg font-bold text-gray-800">DEVIS</h4>
            <p className="text-sm text-gray-600">N° {devisData.number}</p>
            <p className="text-sm text-gray-600">Date: {devisData.date}</p>
            <p className="text-sm text-gray-600">Client: {devisData.client}</p>
          </div>
          
          {/* Lignes */}
          <div className="space-y-2">
            {devisData.lines.map((line, index) => (
              <div key={index} className="flex justify-between text-sm">
                <span className="flex-1">{line.description}</span>
                <span className="w-16 text-center">{line.quantity}</span>
                <span className="w-20 text-right">{line.unitPrice.toFixed(2)} €</span>
                <span className="w-20 text-right font-medium">{line.total.toFixed(2)} €</span>
              </div>
            ))}
          </div>
          
          {/* Total */}
          <div className="border-t pt-3 space-y-1">
            <div className="flex justify-between text-sm">
              <span>Sous-total:</span>
              <span>{devisData.subtotal.toFixed(2)} €</span>
            </div>
            <div className="flex justify-between text-sm">
              <span>TVA (20%):</span>
              <span>{devisData.tax.toFixed(2)} €</span>
            </div>
            <div className="flex justify-between font-bold text-lg">
              <span>Total:</span>
              <span className="text-green-600">{devisData.total.toFixed(2)} €</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Actions */}
      <div className="p-4 border-t bg-gray-50">
        <div className="flex gap-2">
          <button className="flex-1 bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition-colors">
            Imprimer
          </button>
          <button className="flex-1 bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition-colors">
            Convertir en facture
          </button>
        </div>
      </div>
    </div>
  );
};

const WorkshopLayout = ({ 
  // États
  commandes,
  currentCommande,
  selectedLineIndex,
  currentCommandeIndex,
  
  // Fonctions
  addProductToCurrentCommande,
  setSelectedLineIndex,
  updateItemQuantity,
  removeItemFromCommande,
  clearCurrentCommande,
  createNewCommande,
  switchToCommande
}) => {
  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Barre de statut avec sélection client */}
      <div className="bg-white border-b border-gray-200">
        <StatusBar />
        <div className="px-4 py-2 bg-orange-50 border-b">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-orange-700">Client sélectionné:</span>
            <span className="text-sm text-orange-600">Garage Martin</span>
          </div>
        </div>
      </div>
      
      {/* Contenu principal */}
      <div className="flex-1 flex gap-4 p-4 overflow-hidden">
        {/* Colonne gauche - Lignes de devis */}
        <div className="flex-1">
          <EditableLineTable />
        </div>
        
        {/* Colonne droite - Client, Aperçu et Clavier */}
        <div className="w-96 flex flex-col gap-4">
          {/* Client */}
          <div className="h-48">
            <ClientSelector />
          </div>
          
          {/* Aperçu devis */}
          <div className="flex-1">
            <DevisPreview />
          </div>
          
          {/* Clavier virtuel */}
          <div className="h-64">
            <VirtualKeypad 
              selectedLineIndex={selectedLineIndex}
              currentCommande={currentCommande}
              clearCurrentCommande={clearCurrentCommande}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkshopLayout; 